import { loginObj } from '@/services/base';
import axios from 'axios';
import setupInterceptors from '@/services/setupInterceptors';
import tasks from '@/js/tasks';
var configuration = JSON.parse(process.env.VUE_APP_API_GTW_CONFIG);
//console.log(configuration)
// declare service gtw
var appApisGTW = null;
if (!configuration['attributes']) {
  appApisGTW = axios.create({
    baseURL: 'http://localhost{PORT}'.replace('{PORT}', ':8000')
  });
} else {
  appApisGTW = axios.create({
    baseURL: process.env.VUE_APP_API_GTW.replace('{PORT}', ':8000')
  });
}
setupInterceptors(appApisGTW);
export default {
  getCompanyFlags: function getCompanyFlags(companyCode) {
    // OK new company code
    var login = loginObj();
    var body = {
      login: login
    };
    return appApisGTW.get("/api/v1/attribute-management/attr-flags/company", body, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (response) {
      return response.data;
    });
  }
};